import React from "react";   // ✅ Tambahkan ini di paling atas

// ✅ Fungsi utilitas auto-detect device (Safari, Chrome, Android, iOS, Desktop)
export function getWhatsAppUrl(phone = "6281354950219", text = "Hallo, mau pesan") {
  const message = encodeURIComponent(text);

  const ua = navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const whatsappAppUrl = `whatsapp://send?phone=${phone}&text=${message}`;
  const whatsappWebUrl = `https://wa.me/${phone}?text=${message}`;

  if (isMobile && !isSafari) {
    return whatsappAppUrl; // Android/iOS non-Safari → buka app
  }

  return whatsappWebUrl; // Safari & Desktop → fallback aman
}

// ✅ Contoh komponen Link
export const WhatsAppLink = ({ phone = "6281354950219", text = "Hallo, mau pesan" }) => (
  <a
    href={getWhatsAppUrl(phone, text)}
    className="whatsapp_float"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fa fa-whatsapp whatsapp-icon"></i>
  </a>
);

// ✅ Contoh komponen Button
export const WhatsAppButton = ({ phone = "6281354950219", text = "Hallo, mau pesan" }) => {
  const handleClick = () => {
    window.location.href = getWhatsAppUrl(phone, text);
  };

  return (
    <button className="btn" onClick={handleClick}>
      Pesan via WhatsApp
    </button>
  );
};
